let prefix = '/api/operativeStructure';

function getStructure() {
    return window.axios.get(prefix);
}

export default {
    getStructure
}